export const APIHeaderKeys = {
	X_AUTH_TOKEN: 'x-auth-token',
	API_INFO: 'api-info',
	USER_AGENT: 'user-agent'
};
